import { Checkbox, Flex, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  name: string;
  role: string;
  checked: boolean;
  onToggle: () => void;
  ariaLabel?: string;
};

export function AttendeeRow({ name, role, checked, onToggle, ariaLabel }: Props) {
  return (
    <Flex align="center" gap="sm" py="xxxs">
      <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10" style={{ width: 160 }}>
        {name}
      </Text>
      <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.6" style={{ flex: 1 }}>
        {role}
      </Text>
      <Checkbox checked={checked} onChange={onToggle} aria-label={ariaLabel ?? name} />
    </Flex>
  );
}
